import * as React from "react";
import { DialogTitle } from "@mui/material";
import { Grid, Typography } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import { blue } from "@mui/material/colors";

export default function ConditionsOfUseV2() {
  const [open, setOpen] = React.useState(false);
  const [isYes, setIsYes] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsYes(false);
  };
  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Grid>
        <Grid item>
          <label
            style={{
              color: "gray",
              "&:hover": {
                cursor: "pointer",
                color: "white",
              },
            }}
            onClick={handleClickOpen}
          >
            Conditions Of Use
          </label>

          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>{process.env.REACT_APP_SITE_DOMAIN_NAME}</DialogTitle>
            <hr />
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <br />
                <Typography variant="h3" component="div" gutterBottom>
                  Conditions of Use
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="700"
                  component="div"
                  gutterBottom
                >
                  {
                    process.env
                      .REACT_APP_SITE_COMPANY_CONDITION_OF_USE_POLICY_DATE
                  }

                  <hr />
                </Typography>
                <Typography variant="body2">
                  <p>
                    Welcome to {process.env.REACT_APP_SITE_DOMAIN_NAME}.{" "}
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} and/or its
                    affiliates ("{process.env.REACT_APP_SITE_DOMAIN_NAME}")
                    provide website <br />
                    features and other products and services to you when you
                    visit or shop at {process.env.REACT_APP_SITE_DOMAIN_NAME},
                    use {process.env.REACT_APP_SITE_DOMAIN_NAME}
                    <br />
                    products or services, use{" "}
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} applications for
                    mobile, or use software provided by{" "}
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} <br />
                    in connection with any of the foregoing (collectively, "
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} Services"). By
                    using the <br />
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} Services, you
                    agree, on behalf of yourself and all members of your
                    household and others <br />
                    who use any Service under your account, to the following
                    conditions.
                  </p>
                  <br />
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="700"
                  component="div"
                  gutterBottom
                >
                  <p>Please read these conditions carefully.</p>
                </Typography>
                <Typography variant="body2">
                  We offer a wide range of{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Services, and
                  sometimes additional terms may apply. When you use a{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Service
                  <br />
                  (for example, Your Profile,{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} applications) you
                  also will be subject to the guidelines, terms and agreements
                  <br />
                  applicable to that {
                    process.env.REACT_APP_SITE_DOMAIN_NAME
                  }{" "}
                  Service ("Service Terms"). I these Conditions of Use are
                  inconsistent with the Service Terms,
                  <br />
                  those Service Terms will control.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  PRIVACY
                </Typography>
                <Typography variant="body2">
                  <p>
                    Please review our Privacy Notice, which also governs your
                    use of {process.env.REACT_APP_SITE_DOMAIN_NAME} Services, to
                    understand our practices
                  </p>
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  ELECTRONIC COMMUNICATIONS
                </Typography>
                <Typography variant="body2">
                  When you use {process.env.REACT_APP_SITE_DOMAIN_NAME}{" "}
                  Services, or send e-mails, text messages, and other
                  communications from your desktop or mobile device to us,
                  <br />
                  you may be communicating with us electronically. You consent
                  to receive communications from us electronically, such as
                  e-mails, texts, <br />
                  mobile push notices, or notices and messages on this site or
                  through the other {
                    process.env.REACT_APP_SITE_DOMAIN_NAME
                  }{" "}
                  Services, such as our Message
                  <br />
                  Center, and you can retain copies of these communications for
                  your records. You agree that all agreements, notices,
                  disclosures, and
                  <br />
                  other communications that we provide to you electronically
                  satisfy any legal requirement that such communications be in
                  writing.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  COPYRIGHT
                </Typography>
                <Typography variant="body2">
                  All content included in or made available through any
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Service, such as
                  text, graphics, logos, button icons,
                  <br /> images, audio clips, digital downloads, data
                  compilations, and software is <br />
                  the property of {process.env.REACT_APP_SITE_DOMAIN_NAME} or
                  its content suppliers and protected by United States and
                  international copyright laws.
                  <br />
                  The compilation of all content included in or made available
                  through any {process.env.REACT_APP_SITE_DOMAIN_NAME} Service
                  is the exclusive <br />
                  property of {process.env.REACT_APP_SITE_DOMAIN_NAME} and
                  protected by U.S. and international copyright laws.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  TRADEMARKS
                </Typography>
                <Typography variant="body2">
                  <p className="textBody">
                    Click here to see a non-exhaustive list of{" "}
                    {process.env.REACT_APP_SITE_DOMAIN_NAME}
                    trademarks. In addition, graphics, logos, page headers,
                    button <br />
                    icons, scripts, and service names included in or made
                    available through any{" "}
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} Service are
                    trademarks or trade dress of
                    <br />
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} in the U.S. and
                    other countries. {process.env.REACT_APP_SITE_DOMAIN_NAME}'
                    trademarks and trade dress may not be used in connection
                    with
                    <br />
                    any product or service that is not{" "}
                    {process.env.REACT_APP_SITE_DOMAIN_NAME}', in any manner
                    that is likely to cause confusion among customers, or in any
                    <br />
                    manner that disparages or discredits{" "}
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} .<br /> All other
                    trademarks not owned by{" "}
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} that appear in any
                    {process.env.REACT_APP_SITE_DOMAIN_NAME} Service are the
                    property of their respective owners,
                    <br />
                    who may or may not be affiliated with, connected to, or
                    <br />
                    sponsored by {process.env.REACT_APP_SITE_DOMAIN_NAME} .
                  </p>
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  gutterBottom
                  sx={{ marginTop: "20px" }}
                >
                  LICENSE AND ACCESS
                </Typography>
                <Typography variant="body2" className="textBody">
                  Subject to your compliance with these Conditions of Use and
                  any Service Terms, and your payment of any applicable fees,
                  <br />
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} or its content
                  providers grant you a limited, non-exclusive,
                  non-transferable, non-sublicensable license to
                  <br />
                  access and make personal and non-commercial use of the
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Services. This
                  license does not include any resale or <br />
                  commercial use of any {
                    process.env.REACT_APP_SITE_DOMAIN_NAME
                  }{" "}
                  Service, or its contents; any collection and use of any
                  product listings, descriptions, or prices; any
                  <br />
                  derivative use of any {
                    process.env.REACT_APP_SITE_DOMAIN_NAME
                  }{" "}
                  Service or its contents; any downloading, copying, or other
                  use of account information for the
                  <br />
                  benefit of any third party; or any use of data mining, robots,
                  or similar data gathering and extraction tools. All rights not
                  <br />
                  expressly granted to you in these Conditions of Use or any
                  Service Terms are reserved and retained by{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} or its licensors,
                  <br />
                  suppliers, publishers, rightsholders, or other content
                  providers. No {process.env.REACT_APP_SITE_DOMAIN_NAME}{" "}
                  Service, nor any part of any
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Service,
                  <br />
                  may be reproduced, duplicated, copied, sold, resold, visited,
                  or otherwise exploited for any commercial purpose without
                  express
                  <br />
                  written consent of Dollareams. You may not frame or utilize
                  framing techniques to enclose any trademark, logo, or other
                  <br />
                  proprietary information (including images, text, page layout,
                  or form) of {process.env.REACT_APP_SITE_DOMAIN_NAME} on
                  without express written consent. You may
                  <br />
                  not use any meta tags or any other "hidden text" utilizing
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}' name or trademarks
                  without the express written consent of <br />
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} . You may not misuse
                  the {process.env.REACT_APP_SITE_DOMAIN_NAME} Services. You may
                  use the {process.env.REACT_APP_SITE_DOMAIN_NAME} Services only
                  as permitted
                  <br />
                  by law. The licenses granted by{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} terminate if you do
                  not comply with these Conditions of Use or any Service Terms.
                  <br />
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  gutterBottom
                  sx={{ marginTop: "20px" }}
                >
                  YOUR ACCOUNT
                </Typography>
                <Typography variant="body2">
                  You may need your own {process.env.REACT_APP_SITE_DOMAIN_NAME}{" "}
                  account to use certain
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Services, and you may
                  be required to be logged in to
                  <br />
                  the account and have a valid payment method associated with
                  it. If there is a problem charging your selected payment
                  method, we may
                  <br />
                  charge any other valid payment method associated with your
                  account. Visit Your Payments to manage your payment options.
                  You
                  <br />
                  are responsible for maintaining the confidentiality of your
                  account and password and for restricting access to your
                  account,
                  <br />
                  and you agree to accept responsibility for all activities that
                  occur under your account or password.{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} does sell
                  <br />
                  products for children, but it sells them to adults, who can
                  purchase with a credit card or other permitted payment method.
                  If
                  <br />
                  you are under 18, you may use the{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Services only with
                  involvement of a parent or guardian. Parents and guardians may
                  <br />
                  create profiles for teenagers in their{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Household. Alcohol
                  listings on {process.env.REACT_APP_SITE_DOMAIN_NAME} are
                  intended for adults. You must
                  <br />
                  be at least 21 years of age to purchase alcohol, or use any
                  site functionality related to alcohol.{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} reserves the right
                  <br />
                  to refuse service, terminate accounts, terminate your rights
                  to use {process.env.REACT_APP_SITE_DOMAIN_NAME} Services,
                  remove or edit content, or cancel orders
                  <br />
                  in its sole discretion.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  REVIEWS, COMMENTS, COMMUNICATIONS, AND OTHER CONTENT
                </Typography>
                <Typography variant="body2">
                  You may post reviews, comments, photos, videos, and other
                  content; send e-cards and other communications; and submit
                  suggestions,
                  <br />
                  ideas, comments, questions, or other information, so long as
                  the content is not illegal, obscene, threatening, defamatory,
                  invasive
                  <br />
                  of privacy, infringing of intellectual property rights
                  (including publicity rights), or otherwise injurious to third
                  parties or
                  <br />
                  objectionable, and does not consist of or contain software
                  viruses, political campaigning, commercial solicitation, chain
                  <br />
                  letters, mass mailings, or any form of "spam" or unsolicited
                  commercial electronic messages. You may not use a false e-mail
                  <br />
                  address, impersonate any person or entity, or otherwise
                  mislead as to the origin of a card or other content.
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} reserves the
                  <br />
                  right (but not the obligation) to remove or edit such content,
                  but does not regularly review posted content. If you do post
                  content
                  <br />
                  or submit material, and unless we indicate otherwise, you
                  grant {process.env.REACT_APP_SITE_DOMAIN_NAME} a nonexclusive,
                  royalty-free, perpetual, irrevocable,
                  <br />
                  and fully sublicensable right to use, reproduce, modify,
                  adapt, publish, perform, translate, create derivative works
                  from,
                  <br />
                  distribute, and display such content throughout the world in
                  any media. You grant {
                    process.env.REACT_APP_SITE_DOMAIN_NAME
                  }{" "}
                  and sublicensees the right to use the
                  <br />
                  name that you submit in connection with such content, if they
                  choose. You represent and warrant that you own or otherwise
                  <br />
                  control all of the rights to the content that you post; that
                  the content is accurate; that use of the content you supply
                  does not
                  <br />
                  violate this policy and will not cause injury to any person or
                  entity; and that you will indemnify{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} for all claims
                  <br />
                  resulting from content you supply.{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} has the right but not
                  the obligation to monitor and edit or remove any activity or
                  <br />
                  content. {process.env.REACT_APP_SITE_DOMAIN_NAME} takes no
                  responsibility and assumes no liability for any content posted
                  by you or any third party.
                  <br />
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  INTELLECTUAL PROPERTY COMPLAINTS
                </Typography>
                <Typography variant="body2">
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} respects the
                  intellectual property of others. If you believe that your
                  intellectual property rights are being
                  <br />
                  infringed, please follow our Notice and Procedure for Making
                  Claims of Copyright Infringement.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  RISK OF LOSS
                </Typography>
                <Typography variant="body2">
                  All purchases of physical items from{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} are made pursuant to
                  a shipment contract. This means that the risk of loss and
                  title
                  <br />
                  for such items pass to you upon our delivery to the carrier.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  RETURNS, REFUNDS AND TITLE
                </Typography>
                <Typography variant="body2">
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} does not take title
                  to returned items until the item arrives at our address . At
                  our discretion, a refund may be issued
                  <br />
                  without requiring a return. In this situation,{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}
                  does not take title to the refunded item. For more information
                  about
                  <br />
                  our returns and refunds, please see our Returns and/or Refunds
                  Policy(ies).
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  PRODUCT DESCRIPTIONS
                </Typography>
                <Typography variant="body2">
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} attempts to be as
                  accurate as possible. However,
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} does not warrant that
                  product descriptions or other
                  <br />
                  content of any {process.env.REACT_APP_SITE_DOMAIN_NAME}{" "}
                  Service is accurate, complete, reliable, current, or
                  error-free. If a product offered by
                  <br />
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} itself is not as
                  described, your sole remedy is to return it in unused
                  condition
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  PRICING
                </Typography>
                <Typography variant="body2">
                  "List Price" means the suggested retail price of a product as
                  provided by a manufacturer, supplier, or seller. We regularly
                  <br />
                  check List Prices against prices recently found on{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}
                  and other retailers. Certain products may have a "Was Price"
                  <br />
                  displayed, which is determined using recent price history of
                  the product on {process.env.REACT_APP_SITE_DOMAIN_NAME} . With
                  respect to items sold by
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}
                  <br />
                  , we cannot confirm the price of an item until you order.
                  Despite our best efforts, a small number of the items in our
                  catalog may
                  <br />
                  be mispriced. If the correct price of an item sold by
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} is higher than our
                  stated price, we will, at our discretion,
                  <br />
                  either contact you for instructions before shipping or cancel
                  your order and notify you of such cancellation. Other
                  merchants may
                  <br />
                  follow different policies in the event of a mispriced item.
                  <br />
                  <br />
                  We generally do not charge your credit card until after your
                  order has entered the shipping process or, for digital
                  products, until
                  <br />
                  we make the digital product available to you.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  APP PERMISSIONS
                </Typography>
                <Typography variant="body2">
                  When you use apps created by{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} , such as the
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} App , you may grant
                  certain permissions to us for your device.
                  <br />
                  Most mobile devices provide you with information about these
                  permissions. To learn more about these permissions, click
                  here.
                  <br />
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  SANCTIONS AND EXPORT POLICY
                </Typography>
                <Typography variant="body2">
                  You may not use any {process.env.REACT_APP_SITE_DOMAIN_NAME}{" "}
                  Service if you are the subject of U.S. sanctions or of
                  sanctions consistent with U.S. law imposed by
                  <br />
                  the governments of the country where you are using Dollareams
                  Services. You must comply with all U.S. or other export and
                  <br />
                  re-export restrictions that may apply to goods, software
                  (including {process.env.REACT_APP_SITE_DOMAIN_NAME} Software),
                  technology, and services.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  OTHER BUSINESSES
                </Typography>
                <Typography variant="body2">
                  Parties other than {process.env.REACT_APP_SITE_DOMAIN_NAME}{" "}
                  operate stores, provide services or software, or sell product
                  lines through the
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Services. <br />
                  In addition, we provide links to the sites of affiliated
                  companies and certain other businesses. If you purchase any of
                  the products <br />
                  or services offered by these businesses or individuals, you
                  are purchasing directly from those third parties, not from
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} <br />. We are not
                  responsible for examining or evaluating, and we do not
                  warrant, the offerings of any of these businesses or <br />
                  individuals (including the content of their Web sites).
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} does not assume any
                  responsibility or liability for <br />
                  the actions, product, and content of all these and any other
                  third parties. You should carefully review their privacy
                  statements and <br />
                  other conditions of use.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY
                </Typography>
                <Typography variant="body2">
                  THE {process.env.REACT_APP_SITE_DOMAIN_NAME} SERVICES AND ALL
                  INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE){" "}
                  <br />
                  AND OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO
                  YOU THROUGH THE {process.env.REACT_APP_SITE_DOMAIN_NAME}{" "}
                  SERVICES
                  <br />
                  ARE PROVIDED BY {process.env.REACT_APP_SITE_DOMAIN_NAME} ON AN
                  "AS IS" AND "AS AVAILABLE" BASIS,
                  <br />
                  UNLESS OTHERWISE SPECIFIED IN WRITING.{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} MAKES NO
                  REPRESENTATIONS OR WARRANTIES OF ANY KIND, <br />
                  EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}
                  SERVICES, <br />
                  OR THE INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING
                  SOFTWARE) OR OTHER
                  <br />
                  SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU
                  THROUGH
                  <br />
                  THE {process.env.REACT_APP_SITE_DOMAIN_NAME} SERVICES, UNLESS
                  OTHERWISE SPECIFIED IN WRITING.
                  <br />
                  YOU EXPRESSLY AGREE THAT YOUR USE OF THE{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} SERVICES IS
                  <br />
                  AT YOUR SOLE RISK.
                  <p />
                  TO THE FULL EXTENT PERMISSIBLE BY LAW,{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} DISCLAIMS ALL
                  <br />
                  WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
                  IMPLIED WARRANTIES OF MERCHANTABILITY <br />
                  AND FITNESS FOR A PARTICULAR PURPOSE.{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} DOES NOT WARRANT THAT
                  THE {process.env.REACT_APP_SITE_DOMAIN_NAME} SERVICES,
                  INFORMATION, CONTENT, <br /> MATERIALS, PRODUCTS (INCLUDING
                  SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE
                  AVAILABLE TO YOU THROUGH THE <br />{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} SERVICES,{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}' SERVERS OR
                  ELECTRONIC COMMUNICATIONS SENT FROM{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} ARE FREE OF VIRUSES
                  OR OTHER <br />
                  HARMFUL COMPONENTS. TO THE FULL EXTENT PERMISSIBLE BY LAW,
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} WILL NOT BE LIABLE
                  FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF ANY{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} SERVICE, OR
                  <br />
                  FROM ANY INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING
                  SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE
                  <br />
                  AVAILABLE TO YOU THROUGH ANY{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} SERVICE, INCLUDING,
                  BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND
                  <br />
                  CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN WRITING.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  DAPPLICABLE LAW
                </Typography>
                <Typography variant="body2">
                  By using any {process.env.REACT_APP_SITE_DOMAIN_NAME} Service,
                  you agree that applicable federal law, and the laws of the
                  state of New Jersey, without
                  <br />
                  regard to principles of conflict of laws, will govern these
                  Conditions of Use and any dispute of any sort that might arise
                  <br />
                  between you and {process.env.REACT_APP_SITE_DOMAIN_NAME}.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  SITE POLICIES, MODIFICATION, AND SEVERABILITY
                </Typography>
                <Typography variant="body2">
                  Please review our other policies, such as our pricing policy,
                  posted on this site. These policies also govern your use of
                  <br />
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Services. We reserve
                  the right to make changes to our site, policies, Service
                  Terms, and these Conditions of Use at any
                  <br />
                  time. If any of these conditions shall be deemed invalid,
                  void, or for any reason unenforceable, that condition shall be
                  deemed
                  <br />
                  severable and shall not affect the validity and enforceability
                  of any remaining condition.
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  <p>
                    {
                      process.env
                        .REACT_APP_SITE_CONDITION_OF_USE_COY_PHY_ADDRESS_LABEL
                    }
                    <br />
                    <hr />
                    {process.env.REACT_APP_SITE_DOMAIN_NAME}.
                    <br />
                    {
                      process.env
                        .REACT_APP_SITE_CONDITION_OF_USE_COY_STREET_ADDRESS
                    }
                    ,
                    <br />
                    {
                      process.env
                        .REACT_APP_SITE_CONDITION_OF_USE_COY_ADDRESS_CITY
                    }
                    ,{" "}
                    {
                      process.env
                        .REACT_APP_SITE_CONDITION_OF_USE_COY_ADDRESS_STATE
                    }{" "}
                    {
                      process.env
                        .REACT_APP_SITE_CONDITION_OF_USE_COY_ADDRESS_ZIPCODE
                    }{" "}
                    <br />
                    <br />
                    ADDITIONAL {process.env.REACT_APP_SITE_DOMAIN_NAME} SOFTWARE
                    TERMS
                    <br />
                  </p>
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  The following terms (“Software Terms”) apply to any software
                  (including any updates or upgrades to the software) and any
                  <br />
                  related documentation we make available to you in connection
                  with {process.env.REACT_APP_SITE_DOMAIN_NAME} Services (the "
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Software").
                  <br />
                  <p></p>
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  Use of the {process.env.REACT_APP_SITE_DOMAIN_NAME} Software.
                  You may use {process.env.REACT_APP_SITE_DOMAIN_NAME}
                  Software solely for purposes of enabling you to use the
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}
                  <br />
                  Services as provided by{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} , and as permitted by
                  these Conditions of Use and any Service Terms. You may not
                  incorporate
                  <br />
                  any portion of the {
                    process.env.REACT_APP_SITE_DOMAIN_NAME
                  }{" "}
                  Software into other programs or compile any portion of it in
                  combination with other programs, or
                  <br />
                  otherwise copy (except to exercise rights granted in this
                  section), modify, create derivative works of, distribute,
                  assign
                  <br />
                  any rights to, or license the{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Software in whole or
                  in part. All software used in any{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Service is the
                  property
                  <br />
                  of {process.env.REACT_APP_SITE_DOMAIN_NAME} or its software
                  suppliers and is protected by United States and international
                  copyright laws.
                  <br />
                  <br />
                  <p></p>
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  Use of Third Party Services. When you use the{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}
                  Software, you may also be using the services of one or more
                  third
                  <br />
                  parties, such as a wireless carrier or a mobile software
                  provider. Your use of these third party services may be
                  subject to the
                  <br />
                  separate policies, terms of use, and fees of these third
                  parties.
                  <br />
                  <p></p>
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  No Reverse Engineering. You may not reverse engineer,
                  decompile or disassemble, tamper with, or bypass any security
                  associated with
                  <br />
                  the {process.env.REACT_APP_SITE_DOMAIN_NAME} Software, whether
                  in whole or in part.
                  <br />
                  <p></p>
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  Updates. We may offer automatic or manual updates to the
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Software at any time
                  and without notice to you.
                  <br />
                  <p></p>
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  Government End Users. If you are a U.S. Government end user,
                  we are licensing the {process.env.REACT_APP_SITE_DOMAIN_NAME}{" "}
                  Software to you as a "Commercial
                  <br />
                  Item" as that term is defined in the U.S. Code of Federal
                  Regulations (see 48 C.F.R. § 2.101), and the rights we grant
                  you
                  <br />
                  to the {process.env.REACT_APP_SITE_DOMAIN_NAME} Software are
                  the same as the rights we grant to all others under these
                  Conditions of Use.
                  <br />
                  <br />
                  <p></p>
                </Typography>
                <Typography variant="body2">
                  Conflicts. In the event of any conflict between these
                  Conditions of Use and any other{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} or third-party terms
                  applicable
                  <br />
                  to any portion of {
                    process.env.REACT_APP_SITE_DOMAIN_NAME
                  }{" "}
                  Software, such as open-source license terms, such other terms
                  will control as to that portion of
                  <br />
                  the {process.env.REACT_APP_SITE_DOMAIN_NAME} Software and to
                  the extent of the conflict.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  HOW TO SERVE A SUBPOENA OR OTHER LEGAL PROCESS
                </Typography>
                <Typography variant="body2">
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} accepts service of
                  subpoenas or other legal process only through{" "}
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}' national registered
                  agent. Subpoenas or
                  <br />
                  other legal process may be served by sending them to the
                  following address:
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}.
                  <br />
                  {
                    process.env
                      .REACT_APP_SITE_CONDITION_OF_USE_COY_STREET_ADDRESS
                  }
                  ,
                  <br />
                  {process.env.REACT_APP_SITE_CONDITION_OF_USE_COY_ADDRESS_CITY}
                  ,{" "}
                  {
                    process.env
                      .REACT_APP_SITE_CONDITION_OF_USE_COY_ADDRESS_STATE
                  }{" "}
                  {
                    process.env
                      .REACT_APP_SITE_CONDITION_OF_USE_COY_ADDRESS_ZIPCODE
                  }
                  <br />
                  Attn: Legal Department – Legal Process
                  <br />
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  Please note also that providing detailed and accurate
                  information at the outset will facilitate efficient processing
                  of your
                  <br />
                  request. That information will include, for example, e-mail
                  and/or credit card number used to make purchases for retail
                  purchase
                  <br />
                  information; the name, e-mail, and physical address of a
                  seller for seller information; device serial number for
                  {process.env.REACT_APP_SITE_DOMAIN_NAME}
                  <br />
                  devices; and IP address and complete time stamps.
                  <br />
                </Typography>
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  NOTICE AND PROCEDURE FOR MAKING CLAIMS OF INTELLECTUAL
                  PROPERTY INFRINGEMENT
                </Typography>
                <Typography variant="body2">
                  If you believe that your intellectual property rights have
                  been infringed, please submit your complaint using our online
                  form.
                  <br />
                  This form may be used to report all types of intellectual
                  property claims including, but not limited to, copyright,
                  trademark, and patent claims.
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  We respond quickly to the concerns of rights owners about any
                  alleged infringement, and we terminate repeat infringers in
                  <br />
                  appropriate circumstances
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  We offer the following alternative to our online form for
                  copyright complaints only. You may submit written claims of
                  <br />
                  copyright infringement to our Copyright Agent at:
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  Copyright Agent
                  <br />
                  {process.env.REACT_APP_SITE_DOMAIN_NAME} Legal Department,
                  <br />
                  {
                    process.env
                      .REACT_APP_SITE_CONDITION_OF_USE_COY_STREET_ADDRESS
                  }
                  ,
                  <br />
                  {process.env.REACT_APP_SITE_CONDITION_OF_USE_COY_ADDRESS_CITY}
                  ,{" "}
                  {
                    process.env
                      .REACT_APP_SITE_CONDITION_OF_USE_COY_ADDRESS_STATE
                  }{" "}
                  {
                    process.env
                      .REACT_APP_SITE_CONDITION_OF_USE_COY_ADDRESS_ZIPCODE
                  }
                  <br />
                  phone: {process.env.REACT_APP_SITE_COMPANY_PHONE_NUMBER}
                  <br />
                  e-mail: {process.env.REACT_APP_SITE_COMPANY_EMAIL}
                  <br />
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  Written claims concerning copyright infringement must include
                  the following information:
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "10px" }}
                >
                  A physical or electronic signature of the person authorized to
                  act on behalf of the owner of the copyright interest;
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "10px" }}
                >
                  A description of the copyrighted work that you claim has been
                  infringed upon
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  A description of where the material that you claim is
                  infringing is located on the site;
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  Your address, telephone number, and e-mail address;
                  <br />
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  A statement by you that you have a good-faith belief that the
                  disputed use is not authorized by the copyright owner, its
                  agent,
                  <br />
                  or the law; and
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                >
                  A statement by you, made under penalty of perjury, that the
                  above information in your notice is accurate and that you are
                  the
                  <br />
                  copyright owner or authorized to act on the copyright owner's
                  behalf.
                </Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                ></Typography>
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ marginTop: "20px" }}
                ></Typography>
              </DialogContentText>
            </DialogContent>
            <hr />
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            open={isYes}
            autoHideDuration={3000}
            onClose={handleClose}
          ></Snackbar>
        </Grid>
      </Grid>
    </Stack>
  );
}
